import React, { useState } from "react";
import Notiflix from "notiflix";

import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Table,
  Typography,
  Spin,
  Divider,
  Tooltip,
  Modal,
} from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

import { BOM } from "../../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import styles from "../../../../../assets/styles/styles";

const { Text, Title } = Typography;

const TermsForm = (props) => {
  const {
    handleUseBorrowerCycle,
    useBorrowerCycle,
    handleIsLinkedToFloatingInterestRates,
    isLinkedToFloatingInterestRates,
    onFinish,
    form,
    initialValues,
    valueConditionTypeOptions,
    floatingRateOptions,
    setPrincipalByLoanCycleSource,
    principalByLoanCycleSource,
    repaymentsByLoanCycleSource,
    setRepaymentsByLoanCycleSource,
    setInterestRateByLoanCycleSource,
    interestRateByLoanCycleSource,
    interestRateFrequencyTypeOptions,
  } = props;

  console.log(interestRateFrequencyTypeOptions);

  const [count, setCount] = useState(1);

  const handlePrincipalDelete = (key) => {
    let action = "Delete  ";
    let label = "Principal";
    // let label = BOM.SubstringFormat(key.fundSourceAccountValue, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = principalByLoanCycleSource.filter(
          (item) => item.id !== key.id
        );
        setPrincipalByLoanCycleSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const handleRepaymentDelete = (key) => {
    let action = "Delete  ";
    let label = "Repayment";
    // let label = BOM.SubstringFormat(key.fundSourceAccountValue, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = repaymentsByLoanCycleSource.filter(
          (item) => item.id !== key.id
        );
        setRepaymentsByLoanCycleSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const handleInterestRateDelete = (key) => {
    let action = "Delete  ";
    let label = "Interest Rate";
    // let label = BOM.SubstringFormat(key.fundSourceAccountValue, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = interestRateByLoanCycleSource.filter(
          (item) => item.id !== key.id
        );
        setInterestRateByLoanCycleSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: "Principal Value Usage Condition",
      dataIndex: "principalValueUsageCondition",
    },
    {
      title: "Loan Cycle",
      dataIndex: "principalCycleNumber",
    },
    {
      title: "Minimum",
      dataIndex: "minPrincipalPerCycle",
    },
    {
      title: "Default",
      dataIndex: "PrincipalPerCycle",
    },
    {
      title: "Maximum",
      dataIndex: "maxPrincipalPerCycle",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        principalByLoanCycleSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handlePrincipalDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const repaymentColumns = [
    {
      title: "Repayment Value Usage Condition",
      dataIndex: "repaymentValueUsageCondition",
    },
    {
      title: "Loan Cycle",
      dataIndex: "repaymentCycleNumber",
    },
    {
      title: "Minimum",
      dataIndex: "minRepaymentPerCycle",
    },
    {
      title: "Default",
      dataIndex: "repaymentPerCycle",
    },
    {
      title: "Maximum",
      dataIndex: "maxRepaymentPerCycle",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        repaymentsByLoanCycleSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleRepaymentDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  const interestRateColumns = [
    {
      title: "Interest Rate Value Usage Condition",
      dataIndex: "interestRateValueUsageCondition",
    },
    {
      title: "Loan Cycle",
      dataIndex: "interestRateCycleNumber",
    },
    {
      title: "Minimum",
      dataIndex: "minInterestRatePerCycle",
    },
    {
      title: "Default",
      dataIndex: "interestRatePerCycle",
    },
    {
      title: "Maximum",
      dataIndex: "maxInterestRatePerCycle",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        interestRateByLoanCycleSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleInterestRateDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={initialValues}
      style={{ margin: 30 }}
    >
      <Row>
        <Divider orientation="left" orientationMargin="0">
          {" "}
          Deal Value
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Minimum</Text>}
            name={"minPrincipal"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder="minimum" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Default</Text>}
            name={"principal"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder="Default" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Maximum</Text>}
            name={"maxPrincipal"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder="Maximum" />
          </Form.Item>
        </Col>

        {useBorrowerCycle && (
          <>
            <PrincipalByLoanCycleModal
              setPrincipalByLoanCycleSource={setPrincipalByLoanCycleSource}
              principalByLoanCycleSource={principalByLoanCycleSource}
              count={count}
              setCount={setCount}
              valueConditionTypeOptions={valueConditionTypeOptions}
            />
            {principalByLoanCycleSource?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {principalByLoanCycleSource.length > 1
                      ? "Principals by Loan Cycle "
                      : "Principal by Loan Cycle"}
                  </Title>
                </Divider>
                <Col span={24}>
                  <Table
                    columns={columns}
                    dataSource={principalByLoanCycleSource}
                    bordered
                    pagination={{
                      position: "bottomCentre",
                      pageSize: "10",
                    }}
                  />
                </Col>
              </>
            )}
          </>
        )}

        <Divider orientation="left" orientationMargin="0">
          Tenor (Days)
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Minimum</Text>}
            name={"minNumberOfRepayments"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder="minimum" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Default</Text>}
            name={"numberOfRepayments"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder="Default" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Maximum</Text>}
            name={"maxNumberOfRepayments"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input placeholder="Maximum" />
          </Form.Item>
        </Col>

        {useBorrowerCycle && (
          <>
            <NumberOfRepaymentsByLoanCycleModal
              setRepaymentsByLoanCycleSource={setRepaymentsByLoanCycleSource}
              repaymentsByLoanCycleSource={repaymentsByLoanCycleSource}
              valueConditionTypeOptions={valueConditionTypeOptions}
              count={count}
              setCount={setCount}
            />

            {repaymentsByLoanCycleSource?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {repaymentsByLoanCycleSource.length > 1
                      ? "Repayments by Loan Cycle "
                      : "Repayment by Loan Cycle"}
                  </Title>
                </Divider>
                <Col span={24}>
                  <Table
                    columns={repaymentColumns}
                    dataSource={repaymentsByLoanCycleSource}
                    bordered
                    pagination={{
                      position: "bottomCentre",
                      pageSize: "10",
                    }}
                  />
                </Col>
              </>
            )}
          </>
        )}

        {!isLinkedToFloatingInterestRates ? (
          <Divider orientation="left" orientationMargin="0">
            Rate
          </Divider>
        ) : (
          <Divider orientation="left" orientationMargin="0">
            Floating Interest rate
          </Divider>
        )}

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={"Is Linked To Floating Interest rates?"}
            name="isLinkedToFloatingInterestRates"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              showSearch
              onChange={handleIsLinkedToFloatingInterestRates}
              value={isLinkedToFloatingInterestRates}
            />{" "}
          </Form.Item>
        </Col>

        {!isLinkedToFloatingInterestRates ? (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Mininmum Rate</Text>}
                name={"minInterestRatePerPeriod"}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Input placeholder="minimum" />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Default Rate</Text>}
                name={"interestRatePerPeriod"}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Input placeholder="Default" />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Maximum Rate</Text>}
                name={"maxInterestRatePerPeriod"}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Input placeholder="Maximum" />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"interestRateFrequencyType"}
                label={<Text>Rate Frequency</Text>}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  placeholder="Please select a value"
                  options={interestRateFrequencyTypeOptions}
                />
              </Form.Item>
            </Col>
          </>
        ) : (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={<Text>Rate</Text>} name={"floatingrateoptions"}>
                <Select
                  placeholder="Please select a value"
                  options={floatingRateOptions}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Differential Interest</Text>}
                name={"differentialinterest"}
              >
                <Input placeholder="Differential Interest" />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={<Text>Minimum</Text>} name={"minValue"}>
                <Input placeholder="Minimum" />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={<Text>Default</Text>} name={"default"}>
                <Input placeholder="Default" />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={<Text>Maximum</Text>} name={"maxValue"}>
                <Input placeholder="Maximum" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={"Is Floating Calculation Allowed?"}
                name="isFloatingInterestRateCalculationAllowed"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${"Option"}`,
                    "select"
                  )}
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>
          </>
        )}

        <Col span={24}>
          {useBorrowerCycle && (
            <>
              <InterestRateByLoanCycleModal
                setInterestRateByLoanCycleSource={
                  setInterestRateByLoanCycleSource
                }
                interestRateByLoanCycleSource={interestRateByLoanCycleSource}
                valueConditionTypeOptions={valueConditionTypeOptions}
                count={count}
                setCount={setCount}
              />

              {interestRateByLoanCycleSource?.length > 0 && (
                <>
                  <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                      {interestRateByLoanCycleSource.length > 1
                        ? "Interest Rates by Loan Cycle "
                        : "Interest Rate by Loan Cycle"}
                    </Title>
                  </Divider>
                  <Col span={24}>
                    <Table
                      columns={interestRateColumns}
                      dataSource={interestRateByLoanCycleSource}
                      bordered
                      pagination={{
                        position: "bottomCentre",
                        pageSize: "10",
                      }}
                    />
                  </Col>
                </>
              )}
            </>
          )}
        </Col>
      </Row>
    </Form>
  );
};

export default TermsForm;

const PrincipalByLoanCycleModal = (props) => {
  const {
    session,
    setPrincipalByLoanCycleSource,
    principalByLoanCycleSource,
    valueConditionTypeOptions,
    assetAccountOptions,
    count,
    setCount,
    handleFundSourceDelete,
  } = props;

  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handlePrincipalByLoanCycleSave = (formValues) => {
    const newPrincipal = {
      key: count,
      id: count,
      principalCycleNumber: formValues.principalCycleNumber,
      principalValueUsageCondition: valueConditionTypeOptions.find(
        (item) => item.value === formValues.principalValueUsageCondition
      ).label,
      principalValueUsageConditionId: valueConditionTypeOptions.find(
        (item) => item.value === formValues.principalValueUsageCondition
      ).value,
      minPrincipalPerCycle: formValues.minPrincipalPerCycle,
      PrincipalPerCycle: formValues.PrincipalPerCycle,
      maxPrincipalPerCycle: formValues.maxPrincipalPerCycle,
    };
    setCount(count + 1);
    setPrincipalByLoanCycleSource([
      ...principalByLoanCycleSource,
      newPrincipal,
    ]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Form.Item label={<Text>Principal By Loan Cycle</Text>}>
        <Button
          type="primary"
          onClick={showModal}
          icon={<PlusOutlined />}
          style={{
            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
            backgroundColor: "#15CCAE",
            marginBottom: 20,
          }}
          shape="round"
        >
          {"Add"}
        </Button>
      </Form.Item>
      <Modal
        title="Principal By Loan Cycle Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handlePrincipalByLoanCycleSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"principalValueUsageCondition"}
                label={"Principal Value Usage Condition"}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Principal Value Usage Condition",
                    "select"
                  )}
                  options={valueConditionTypeOptions}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Loan Cycle</Text>}
                name={"principalCycleNumber"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Minimum Principal per Cycle</Text>}
                name={"minPrincipalPerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Principal per Cycle</Text>}
                name={"PrincipalPerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Maximim Principal per Cycle</Text>}
                name={"maxPrincipalPerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const NumberOfRepaymentsByLoanCycleModal = (props) => {
  const {
    session,
    setRepaymentsByLoanCycleSource,
    repaymentsByLoanCycleSource,
    valueConditionTypeOptions,
    assetAccountOptions,
    count,
    setCount,
    handleFundSourceDelete,
  } = props;

  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleRepaymentsByLoanCycleSave = (formValues) => {
    const newNumberOfRepayment = {
      key: count,
      id: count,
      repaymentValueUsageCondition: valueConditionTypeOptions.find(
        (item) => item.value === formValues.repaymentValueUsageCondition
      ).label,
      repaymentValueUsageConditionId: valueConditionTypeOptions.find(
        (item) => item.value === formValues.repaymentValueUsageCondition
      ).value,
      repaymentCycleNumber: formValues.repaymentCycleNumber,
      minRepaymentPerCycle: formValues.minRepaymentPerCycle,
      repaymentPerCycle: formValues.repaymentPerCycle,
      maxRepaymentPerCycle: formValues.maxRepaymentPerCycle,
    };
    setCount(count + 1);
    setRepaymentsByLoanCycleSource([
      ...repaymentsByLoanCycleSource,
      newNumberOfRepayment,
    ]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Form.Item label={<Text>Repayments By Loan Cycle</Text>}>
        <Button
          type="primary"
          onClick={showModal}
          icon={<PlusOutlined />}
          style={{
            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
            backgroundColor: "#15CCAE",
            marginBottom: 20,
          }}
          shape="round"
        >
          {"Add"}
        </Button>
      </Form.Item>

      <Modal
        title="Repayments By Loan Cycle Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleRepaymentsByLoanCycleSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"repaymentValueUsageCondition"}
                label={"Repayment Value Usage Condition"}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Repayment Value Usage Condition",
                    "select"
                  )}
                  options={valueConditionTypeOptions}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Minimum Principal per Cycle</Text>}
                name={"repaymentCycleNumber"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Repayment per Cycle</Text>}
                name={"minRepaymentPerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Repayment per Cycle</Text>}
                name={"repaymentPerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Maximim Repayment per Cycle</Text>}
                name={"maxRepaymentPerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};

const InterestRateByLoanCycleModal = (props) => {
  const {
    session,
    setInterestRateByLoanCycleSource,
    interestRateByLoanCycleSource,
    valueConditionTypeOptions,
    assetAccountOptions,
    count,
    setCount,
    handleFundSourceDelete,
  } = props;

  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleInterestRateSave = (formValues) => {
    const newInterestRate = {
      key: count,
      id: count,
      interestRateValueUsageCondition: valueConditionTypeOptions.find(
        (item) => item.value === formValues.interestRateValueUsageCondition
      ).label,
      interestRateValueUsageConditionId: valueConditionTypeOptions.find(
        (item) => item.value === formValues.interestRateValueUsageCondition
      ).value,
      interestRateCycleNumber: formValues.interestRateCycleNumber,
      minInterestRatePerCycle: formValues.minInterestRatePerCycle,
      interestRatePerCycle: formValues.interestRatePerCycle,
      maxInterestRatePerCycle: formValues.maxInterestRatePerCycle,
    };
    setCount(count + 1);
    setInterestRateByLoanCycleSource([
      ...interestRateByLoanCycleSource,
      newInterestRate,
    ]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Form.Item label={<Text>Interest Rate By Loan Cycle</Text>}>
        <Button
          type="primary"
          onClick={showModal}
          icon={<PlusOutlined />}
          style={{
            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
            backgroundColor: "#15CCAE",
            marginBottom: 20,
          }}
          shape="round"
        >
          {"Add"}
        </Button>
      </Form.Item>
      <Modal
        title="Interest Rate By Loan Cycle Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleInterestRateSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"interestRateValueUsageCondition"}
                label={"Rate Value Usage Condition"}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Interest Rate Value Usage Condition",
                    "select"
                  )}
                  options={valueConditionTypeOptions}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Interest Rate Cycle Number</Text>}
                name={"interestRateCycleNumber"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Minimum Interest Rate per Cycle</Text>}
                name={"minInterestRatePerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Interest Rate per Cycle</Text>}
                name={"interestRatePerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Maximim Interest Rate per Cycle</Text>}
                name={"maxInterestRatePerCycle"}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
